import React, { useContext, useEffect, useState, useRef } from 'react';
import { inferTipoColuna } from '../lib/inferTipo';
import Chart from './Chart';
import { CHART_TIPOS } from '../lib/chartTypes';
import { GlobalContext } from '../lib/GlobalVar';
import { ConsultaDashboard, SalvaDashboard, ConsultaConstrutor, ConsultaConexoes, ExecutaTelaInterna, ExecutaConsultaSql, ConsultaLogins, ExportaPreset, SincronizaPreset, ReVinculaPresets, RenomeiaPreset, DefinePresetPadrao, ConsultaPresetsPadrao } from '../lib/api';
import Swal from 'sweetalert2';
import Icon from './Icon';
import CompartilharModal from './CompartilharModal';

function saudacao() {
    const h = new Date().getHours();
    if (h < 12) return 'Bom dia';
    if (h < 18) return 'Boa tarde';
    return 'Boa noite';
}

const PRESETS_DEFAULT = {
    p_meu: { name: 'Meu painel', widgets: [] }
};

function defaultWidgets() {
    return [
        { uid: 'kpi1', tipo: 'kpi', titulo: 'Execuções 24h', valor: '142', sub: '+8 vs ontem', w: 3 },
        { uid: 'kpi2', tipo: 'kpi', titulo: 'Taxa sucesso', valor: '97.4%', sub: 'acima do alvo', w: 3 },
        { uid: 'kpi3', tipo: 'kpi', titulo: 'Falhas 24h',  valor: '3',   sub: '+1 vs ontem', w: 3 },
        { uid: 'kpi4', tipo: 'kpi', titulo: 'Tempo médio', valor: '2.4s', sub: '', w: 3 },
        { uid: 'pulso', tipo: 'pulso',     titulo: 'Pulso · rotinas críticas', w: 8 },
        { uid: 'infra', tipo: 'infra',     titulo: 'Infra', w: 4 }
    ];
}

function diretoriaWidgets() {
    return [
        { uid: 'dir_pulso', tipo: 'grafico', graficoTipo: 'kpi',     titulo: 'Faturamento do mes',    origem: 'tela', slug: 'pulso-faturamento', eixoY: 'fat_mes', eixoMeta: 'meta_mes', w: 3 },
        { uid: 'dir_loja',  tipo: 'grafico', graficoTipo: 'bar',     titulo: 'Faturamento por loja',  origem: 'tela', slug: 'fat-loja',          eixoX: 'loja', eixoY: 'realizado', eixoMeta: 'meta_mes', mostrarRotulos: true, w: 9 },
        { uid: 'dir_canal', tipo: 'grafico', graficoTipo: 'donut',   titulo: 'Vendas por canal',      origem: 'tela', slug: 'vendas-canal',      eixoX: 'canal', eixoY: 'liquido', w: 4 },
        { uid: 'dir_vend',  tipo: 'grafico', graficoTipo: 'barh',    titulo: 'Ranking de vendedoras', origem: 'tela', slug: 'ranking-vendedora', eixoX: 'vendedora', eixoY: 'realizado', eixoMeta: 'meta_mes', mostrarRotulos: true, w: 4 },
        { uid: 'dir_forn',  tipo: 'grafico', graficoTipo: 'barh', titulo: 'Top fornecedores (% do faturamento)', origem: 'tela', slug: 'top-fornecedores',  eixoX: 'fornecedor', eixoY: 'pct', mostrarRotulos: true, w: 4 },
        { uid: 'dir_bone', tipo: 'grafico', graficoTipo: 'barh', titulo: 'Bones da Copa (pecas por cor)', origem: 'banco', conexao: 'PG_CLOUD_BD', eixoX: 'bone', eixoY: 'pecas', w: 6, sql: `SELECT b.bone, COALESCE(SUM(i.qtde),0) AS pecas, ROUND(COALESCE(SUM(i.prcvenda*i.qtde),0),2) AS faturamento FROM ( SELECT DISTINCT p.produtos_num_fornecedor AS fab, p.produtos_num_item AS item, COALESCE(REPLACE(pc.procor_descricao_cor,'COPA ',''), 'no'||p.produtos_numero) AS bone FROM erp_produtos p LEFT JOIN erp_produtos_cor pc ON pc.procor_num_fornecedor = p.produtos_num_fornecedor AND pc.procor_num_produto = p.produtos_numero WHERE p.produtos_codigo='15513/6' AND p.produtos_datinc >= '2026-06-15' ) b LEFT JOIN erp_ipedidos i ON i.codigofab = b.fab AND i.codigopro = b.item GROUP BY b.bone ORDER BY pecas DESC` }
    ];
}

const SIZES = [3, 4, 6, 8, 12];

const TIPOS_WIDGET = [
    { id: 'kpi',     label: 'KPI · número',    desc: 'Métrica grande com sub-texto.' },
    { id: 'grafico', label: 'Gráfico',         desc: 'Barras, linha, donut ou pizza.' },
    { id: 'tabela',  label: 'Tabela',          desc: 'Resposta da API em colunas.' },
    { id: 'atalho',  label: 'Atalho de tela',  desc: 'Link para Páginas Internas.' },
    { id: 'html',    label: 'HTML',            desc: 'Bloco HTML livre (texto/imagem).' }
];

const REFRESH_OPTS = [
    { v: 0,    l: 'Manual' },
    { v: 30,   l: '30 segundos' },
    { v: 60,   l: '1 minuto' },
    { v: 300,  l: '5 minutos' },
    { v: 1800, l: '30 minutos' }
];

export default function Dashboard() {
    const { user } = useContext(GlobalContext);
    const isTI = user && (user.setor === 'TI' || user.cargo === 'Administrador');
    const [presets, setPresets] = useState(PRESETS_DEFAULT);
    const [active, setActive] = useState('p_meu');
    const [editing, setEditing] = useState(false);
    const [builderModal, setBuilderModal] = useState(null); // null | widget object (edit) | { isNew: true }
    const [presetMenu, setPresetMenu] = useState(false);
    const [telasBuilt, setTelasBuilt] = useState([]);
    const [drag, setDrag] = useState(null);
    const [compartilharAberto, setCompartilharAberto] = useState(false);
    const [padroes, setPadroes] = useState([]);
    const [periodo, setPeriodo] = useState(() => { const _h = hojeISO(); return { ini: _h.slice(0, 8) + '01', fim: _h }; });
    const pageRef = useRef(null);

    useEffect(() => {
        (async () => {
            const [d, telas, pad] = await Promise.all([ConsultaDashboard({ user_id: user?.id }), ConsultaConstrutor({}), ConsultaPresetsPadrao({})]);
            setTelasBuilt(Array.isArray(telas) ? telas : []);
            if (pad && !pad.Error) setPadroes(pad.padrao || []);
            if (!d.Error && d) {
                const layout = d.layout || d;
                if (layout.presets && Object.keys(layout.presets).length) setPresets(layout.presets);
                if (layout.active) setActive(layout.active);
            }
        })();
    }, [user]);

    const ap = presets[active] || Object.values(presets)[0];

    function setWidgets(next) {
        setPresets(p => ({ ...p, [active]: { ...ap, widgets: next } }));
    }

    function adicionarWidget(w) {
        setWidgets([...(ap.widgets || []), w]);
        setBuilderModal(null);
    }

    function atualizarWidget(w) {
        setWidgets((ap.widgets || []).map(x => x.uid === w.uid ? w : x));
        setBuilderModal(null);
    }

    function removeWidget(uid) { setWidgets((ap.widgets || []).filter(w => w.uid !== uid)); }
    function resizeWidget(uid, delta) {
        setWidgets((ap.widgets || []).map(w => {
            if (w.uid !== uid) return w;
            const idx = SIZES.indexOf(w.w || 4);
            const next = SIZES[Math.max(0, Math.min(SIZES.length - 1, idx + delta))];
            return { ...w, w: next };
        }));
    }

    function onDragStart(uid) { return e => { if (editing) { setDrag(uid); e.dataTransfer.effectAllowed = 'move'; }}; }
    function onDragOver(e) { if (editing && drag) { e.preventDefault(); e.dataTransfer.dropEffect = 'move'; }}
    function onDrop(uid) {
        return e => {
            e.preventDefault();
            if (!drag || drag === uid) return;
            const arr = [...(ap.widgets || [])];
            const fromIdx = arr.findIndex(w => w.uid === drag);
            const toIdx = arr.findIndex(w => w.uid === uid);
            const [moving] = arr.splice(fromIdx, 1);
            arr.splice(toIdx, 0, moving);
            setWidgets(arr);
            setDrag(null);
        };
    }

    async function salvar() {
        const resp = await SalvaDashboard({ solicitante: user?.email, user_id: user?.id, layout: { presets, active } });
        if (resp.Error) return Swal.fire({ icon: 'warning', title: 'Atenção', text: resp.Error });
        setEditing(false);
        Swal.fire({ icon: 'success', title: 'Painel salvo', timer: 1100, showConfirmButton: false });
    }

    function novoPreset() {
        Swal.fire({ title: 'Novo preset', input: 'text', inputPlaceholder: 'Nome do preset', showCancelButton: true, confirmButtonText: 'Criar' }).then(r => {
            if (!r.isConfirmed || !r.value) return;
            const id = `p_${Date.now()}`;
            setPresets({ ...presets, [id]: { name: r.value, widgets: [...(ap.widgets || [])] } });
            setActive(id);
            setPresetMenu(false);
        });
    }

    async function apagarPreset(id) {
        const p = presets[id];
        const c = await Swal.fire({ icon: 'warning', title: `Apagar preset "${p ? p.name : id}"?`, showCancelButton: true, confirmButtonText: 'Apagar', cancelButtonText: 'Cancelar', confirmButtonColor: '#b91c1c' });
        if (!c.isConfirmed) return;
        const np = { ...presets }; delete np[id];
        const novoActive = (active === id) ? (Object.keys(np)[0] || null) : active;
        setPresets(np); setActive(novoActive); setPresetMenu(false);
        await SalvaDashboard({ solicitante: user?.email, user_id: user?.id, layout: { presets: np, active: novoActive } });
        Swal.fire({ icon: 'success', title: 'Preset apagado', timer: 1000, showConfirmButton: false });
    }

    async function exportarPreset(id) {
        const preset = presets[id]; if (!preset) return;
        let lista = [];
        try { const us = await ConsultaLogins({}); lista = Array.isArray(us) ? us : (us.users || []); } catch (_) {}
        lista = lista.filter(u => u && u.id && Number(u.id) !== Number(user?.id));
        const opts = lista.map(u => `<label class="dexp-user" data-busca="${`${u.nome || u.login || ''} ${u.setor || ''}`.toLowerCase()}"><input type="checkbox" value="${u.id}"><span class="dexp-ava">${String(u.nome || u.login || '?').trim().slice(0,1).toUpperCase()}</span><span class="dexp-meta"><span>${u.nome || u.login}</span><span class="dexp-setor">${u.setor || ''}</span></span></label>`).join('');
        const r = await Swal.fire({
            title: `Exportar "${preset.name}"`, width: 520,
            html: `<div style="text-align:left"><div class="muted" style="font-size:12px;margin-bottom:8px">Cada selecionado recebe uma <b>cópia</b> deste preset no dashboard dele.</div><input id="dexp-busca" class="dexp-busca" placeholder="🔍 Buscar pessoa…"><div id="dexp-lista" class="dexp-lista">${opts || '<div class="muted" style="padding:12px">Sem outros usuários.</div>'}</div></div>`,
            showCancelButton: true, confirmButtonText: 'Enviar cópia', cancelButtonText: 'Cancelar', confirmButtonColor: '#0A0A0A',
            didOpen: () => { const b = document.getElementById('dexp-busca'); const l = document.getElementById('dexp-lista'); if (b && l) b.addEventListener('input', () => { const q = b.value.toLowerCase(); l.querySelectorAll('.dexp-user').forEach(el => { el.style.display = el.dataset.busca.includes(q) ? '' : 'none'; }); }); },
            preConfirm: () => Array.from(document.querySelectorAll('#dexp-lista input:checked')).map(c => c.value),
        });
        if (!r.isConfirmed || !r.value || !r.value.length) return;
        let ok = 0;
        for (const alvo of r.value) { const resp = await ExportaPreset({ solicitante: user?.email, alvo_user_id: alvo, preset, nome: preset.name, autor_user_id: user?.id, autor_preset_key: id }); if (resp && !resp.Error) ok++; }
        setPresetMenu(false);
        Swal.fire({ icon: 'success', title: `Enviado para ${ok} conta(s)`, timer: 1400, showConfirmButton: false });
    }

    // Recarrega o layout do consumidor (usado apos sincronizar/re-vincular).
    async function recarregarLayout() {
        const d = await ConsultaDashboard({ user_id: user?.id });
        if (d && !d.Error) {
            const layout = d.layout || d;
            if (layout.presets) setPresets(layout.presets);
            if (layout.active) setActive(layout.active);
        }
    }

    // Sincroniza a copia deste preset com a versao ATUAL do autor (sobrescreve widgets).
    async function sincronizarPreset(id) {
        const resp = await SincronizaPreset({ solicitante: user?.email, consumidor_user_id: user?.id, preset_key: id });
        if (!resp || resp.Error) return Swal.fire({ icon: 'warning', title: 'Nao foi possivel sincronizar', text: (resp && resp.Error) || 'Erro desconhecido.' });
        await recarregarLayout();
        setPresetMenu(false);
        Swal.fire({ icon: 'success', title: 'Sincronizado com o autor', timer: 1400, showConfirmButton: false });
    }

    // Vincula um preset "solto" (sem origem) a um autor: tenta pelo audit; se nao resolver, picker manual.
    async function vincularPreset(id) {
        const resp = await ReVinculaPresets({ solicitante: user?.email, consumidor_user_id: user?.id });
        const aindaSem = !resp || resp.Error || (resp.semMatch || []).some(s => String(s.preset_key) === String(id));
        if (!aindaSem) { await recarregarLayout(); setPresetMenu(false); return Swal.fire({ icon: 'success', title: 'Vinculado ao autor', timer: 1400, showConfirmButton: false }); }
        // Fallback manual: escolher autor + preset do autor.
        let lista = [];
        try { const us = await ConsultaLogins({}); lista = Array.isArray(us) ? us : (us.users || []); } catch (_) {}
        lista = lista.filter(u => u && u.id && Number(u.id) !== Number(user?.id));
        const optsAutor = lista.map(u => `<option value="${u.id}">${u.nome || u.login}${u.setor ? ' · ' + u.setor : ''}</option>`).join('');
        const a = await Swal.fire({
            title: 'Vincular ao autor', width: 460,
            html: `<div style="text-align:left"><div class="muted" style="font-size:12px;margin-bottom:8px">Nao consegui deduzir o autor pelo historico. Escolha manualmente:</div><select id="vinc-autor" class="swal2-select" style="width:100%">${optsAutor}</select></div>`,
            showCancelButton: true, confirmButtonText: 'Ver presets', cancelButtonText: 'Cancelar', confirmButtonColor: '#0A0A0A',
            preConfirm: () => document.getElementById('vinc-autor')?.value,
        });
        if (!a.isConfirmed || !a.value) return;
        const autorId = a.value;
        const d = await ConsultaDashboard({ user_id: autorId });
        const autorPresets = (d && !d.Error) ? ((d.layout || d).presets || {}) : {};
        const optsPreset = Object.entries(autorPresets).map(([k, p]) => `<option value="${k}">${(p && (p.name || p.nome)) || k} (${(p.widgets || []).length} widgets)</option>`).join('');
        if (!optsPreset) return Swal.fire({ icon: 'info', title: 'Autor sem presets', text: 'Esse usuario nao tem presets salvos.' });
        const b = await Swal.fire({
            title: 'Preset do autor', width: 460,
            html: `<select id="vinc-preset" class="swal2-select" style="width:100%">${optsPreset}</select>`,
            showCancelButton: true, confirmButtonText: 'Vincular', cancelButtonText: 'Cancelar', confirmButtonColor: '#0A0A0A',
            preConfirm: () => document.getElementById('vinc-preset')?.value,
        });
        if (!b.isConfirmed || !b.value) return;
        const rp = await ReVinculaPresets({ solicitante: user?.email, consumidor_user_id: user?.id, preset_key: id, autor_user_id: autorId, autor_preset_key: b.value });
        if (!rp || rp.Error) return Swal.fire({ icon: 'warning', title: 'Nao foi possivel vincular', text: (rp && rp.Error) || 'Erro desconhecido.' });
        await recarregarLayout();
        setPresetMenu(false);
        Swal.fire({ icon: 'success', title: 'Vinculado ao autor', timer: 1400, showConfirmButton: false });
    }

    function isPadrao(id) {
        return padroes.some(pd => String(pd.autor_user_id) === String(user?.id) && pd.autor_preset_key === id);
    }

    // Duplicar: copia independente, SEM vinculo de origem - nunca sincroniza com nada.
    async function duplicarPreset(id) {
        const preset = presets[id]; if (!preset) return;
        const r = await Swal.fire({ title: 'Duplicar preset', input: 'text', inputValue: `${preset.name} (cópia)`, inputPlaceholder: 'Nome da cópia', showCancelButton: true, confirmButtonText: 'Duplicar', confirmButtonColor: '#0A0A0A' });
        if (!r.isConfirmed || !r.value) return;
        const resp = await ExportaPreset({ solicitante: user?.email, alvo_user_id: user?.id, preset, nome: r.value, duplicar: true });
        if (!resp || resp.Error) return Swal.fire({ icon: 'warning', title: 'Não foi possível duplicar', text: (resp && resp.Error) || 'Erro desconhecido.' });
        await recarregarLayout();
        setPresetMenu(false);
        Swal.fire({ icon: 'success', title: 'Preset duplicado', text: 'Cópia independente — editar aqui não afeta o original.', timer: 1800, showConfirmButton: false });
    }

    // Renomeia so a etiqueta de exibicao na MINHA conta (nao afeta autor nem outros vinculados).
    async function renomearPreset(id) {
        const preset = presets[id]; if (!preset) return;
        const r = await Swal.fire({ title: 'Renomear preset', input: 'text', inputValue: preset.name, showCancelButton: true, confirmButtonText: 'Renomear', confirmButtonColor: '#0A0A0A' });
        if (!r.isConfirmed || !r.value || !r.value.trim()) return;
        const resp = await RenomeiaPreset({ solicitante: user?.email, user_id: user?.id, preset_key: id, novo_nome: r.value.trim() });
        if (!resp || resp.Error) return Swal.fire({ icon: 'warning', title: 'Não foi possível renomear', text: (resp && resp.Error) || 'Erro desconhecido.' });
        await recarregarLayout();
        setPresetMenu(false);
    }

    // Marca/desmarca como PADRAO: usuarios novos (sem dashboard salvo) recebem uma copia
    // vinculada (vinculo vivo) deste preset automaticamente na primeira visita.
    async function definirPadrao(id) {
        const marcarComo = !isPadrao(id);
        const resp = await DefinePresetPadrao({ solicitante: user?.email, user_id: user?.id, preset_key: id, padrao: marcarComo });
        if (!resp || resp.Error) return Swal.fire({ icon: 'warning', title: 'Não foi possível atualizar', text: (resp && resp.Error) || 'Erro desconhecido.' });
        setPadroes(resp.padrao || []);
        Swal.fire({ icon: 'success', title: marcarComo ? 'Definido como padrão' : 'Removido dos padrões', text: marcarComo ? 'Usuários novos recebem este painel automaticamente.' : '', timer: 1800, showConfirmButton: false });
    }

    return (
        <div className="page" ref={pageRef}>
            {editing && (
                <div className="edit-banner">
                    <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                        <Icon name="edit" size={16}/>
                        <div>
                            <div className="eyebrow">Modo personalização{isTI ? ' · TI' : ''}</div>
                            <div style={{ fontSize: 13.5, marginTop: 2 }}>
                                Arraste pra reordenar, use −/+ pra ajustar largura, × remove. Salvo no preset <strong>{ap.name}</strong>.
                            </div>
                        </div>
                    </div>
                    <div style={{ display: 'flex', gap: 10 }}>
                        <button className="btn ghost sm" style={{ borderColor: 'rgba(245,241,234,0.4)', color: 'var(--bg)' }} onClick={() => setBuilderModal({ isNew: true })}>
                            <Icon name="plus" size={11}/> Adicionar widget
                        </button>
                        <button className="btn sm" style={{ background: 'var(--bg)', color: 'var(--ink)', borderColor: 'var(--bg)' }} onClick={salvar}>
                            <Icon name="check" size={11}/> Salvar
                        </button>
                    </div>
                </div>
            )}

            <div className="page-head">
                <div>
                    <div className="eyebrow"><span className="num">01</span> Visão geral{isTI ? ' · NODECLOUD 177.70.12.42' : ''}</div>
                    <h1 className="page-title">{saudacao()}, {user?.nome?.split(' ')[0] || 'Babita'}.</h1>
                    <p className="page-sub">
                        Painel <strong>{ap.name}</strong> · {(ap.widgets || []).length} widgets. Use Personalizar pra ajustar.
                    </p>
                </div>
                <div className="dash-actions" style={{ display: 'flex', gap: 10, alignItems: 'center', position: 'relative' }} data-no-capture>
                    <div className="field dash-periodo" style={{ flexDirection: 'row', alignItems: 'center', gap: 6, margin: 0 }} title="Filtra os graficos cujo SQL usa os tokens de data {{data_ini}}/{{data_fim}}">
                        <label style={{ margin: 0 }}>Periodo</label>
                        <input type="date" className="input" style={{ width: 150 }} value={periodo.ini} onChange={e => setPeriodo(p => ({ ...p, ini: e.target.value }))}/>
                        <span className="muted">ate</span>
                        <input type="date" className="input" style={{ width: 150 }} value={periodo.fim} onChange={e => setPeriodo(p => ({ ...p, fim: e.target.value }))}/>
                        {(periodo.ini || periodo.fim) && <button className="btn ghost sm" onClick={() => setPeriodo({ ini: '', fim: '' })} title="Limpar periodo">Limpar</button>}
                    </div>
                    <button className="btn ghost sm" onClick={() => setCompartilharAberto(true)} title="Compartilhar dashboard">
                        <Icon name="send" size={11}/> Compartilhar
                    </button>
                    {(
                        <div className="dash-preset-wrap" style={{ position: 'relative' }}>
                            <button className="btn ghost sm" onClick={() => setPresetMenu(s => !s)}>
                                <Icon name="grid" size={12}/> {ap.name} <Icon name="chev-down" size={11}/>
                            </button>
                            {presetMenu && (
                                <>
                                    <div onClick={() => setPresetMenu(false)} style={{ position: 'fixed', inset: 0, zIndex: 5 }}/>
                                    <div className="dash-preset-menu" style={{ position: 'absolute', top: 'calc(100% + 6px)', right: 0, zIndex: 6, minWidth: 280, background: 'var(--paper)', border: '1px solid var(--line)' }}>
                                        <div style={{ padding: '12px 16px 8px', fontSize: 9.5, letterSpacing: '0.24em', textTransform: 'uppercase', color: 'var(--ink-mute)' }}>Presets</div>
                                        {Object.entries(presets).map(([id, p]) => (
                                            <div key={id} className="dash-preset-row" style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '8px 12px 8px 16px', borderLeft: '2px solid ' + (id === active ? 'var(--ink)' : 'transparent'), background: id === active ? 'var(--bg-2)' : 'transparent' }}>
                                                <div style={{ flex: 1, cursor: 'pointer', minWidth: 0 }} onClick={() => { setActive(id); setPresetMenu(false); }}>
                                                    <div style={{ fontSize: 13 }}>{p.name}</div>
                                                    <div style={{ fontSize: 10.5, color: 'var(--ink-mute)', marginTop: 1 }}>{(p.widgets || []).length} widgets{p.origem ? (p.origem.via === 'padrao' ? ' · padrão (vínculo vivo)' : ' · vinculado ao autor (vínculo vivo)') : ''}</div>
                                                </div>
                                                {p.origem ? (
                                                    <button className="btn ghost sm" title="Sincronizar preset com autor (sobrescreve com a versão atual do autor)" onClick={(e) => { e.stopPropagation(); sincronizarPreset(id); }}><Icon name="history" size={12}/></button>
                                                ) : (
                                                    <button className="btn ghost sm" title="Vincular ao autor" onClick={(e) => { e.stopPropagation(); vincularPreset(id); }}><Icon name="link" size={12}/></button>
                                                )}
                                                <button className="btn ghost sm" title="Compartilhar com outra conta (vínculo vivo — atualiza sozinho)" onClick={(e) => { e.stopPropagation(); exportarPreset(id); }}><Icon name="send" size={12}/></button>
                                                <button className="btn ghost sm" title="Renomear" onClick={(e) => { e.stopPropagation(); renomearPreset(id); }}><Icon name="edit" size={12}/></button>
                                                <button className="btn ghost sm" title="Duplicar (cópia independente, sem vínculo)" onClick={(e) => { e.stopPropagation(); duplicarPreset(id); }}><Icon name="copy" size={12}/></button>
                                                {!p.origem && (
                                                    <button className="btn ghost sm" title={isPadrao(id) ? 'Remover como padrão' : 'Definir como padrão (novos usuários recebem automaticamente)'} onClick={(e) => { e.stopPropagation(); definirPadrao(id); }} style={isPadrao(id) ? { color: '#b8860b' } : {}}><Icon name="star" size={12}/></button>
                                                )}
                                                <button className="btn ghost sm" title="Apagar preset" onClick={(e) => { e.stopPropagation(); apagarPreset(id); }}><Icon name="trash" size={12}/></button>
                                            </div>
                                        ))}
                                        <div style={{ borderTop: '1px dashed var(--line)' }}/>
                                        <div onClick={novoPreset} style={{ padding: '10px 16px', cursor: 'pointer', fontSize: 12, display: 'flex', alignItems: 'center', gap: 8 }}>
                                            <Icon name="plus" size={11}/> Novo preset
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    )}
                    <button className="btn sm" onClick={() => setEditing(e => !e)}>
                        <Icon name="edit" size={11}/> {editing ? 'Concluir' : 'Personalizar'}
                    </button>
                </div>
            </div>

            <div className="dash-grid">
                {(ap.widgets || []).map(w => (
                    <WidgetCard
                        key={w.uid}
                        w={w}
                        editing={editing}
                        telasBuilt={telasBuilt}
                        periodo={periodo}
                        onRemove={() => removeWidget(w.uid)}
                        onResize={d => resizeWidget(w.uid, d)}
                        onEdit={() => setBuilderModal(w)}
                        onDragStart={onDragStart(w.uid)}
                        onDragOver={onDragOver}
                        onDrop={onDrop(w.uid)}
                    />
                ))}
            </div>

            {builderModal && (
                <WidgetBuilder
                    widget={builderModal.isNew ? null : builderModal}
                    telasBuilt={telasBuilt}
                    onClose={() => setBuilderModal(null)}
                    onSave={w => (builderModal.isNew ? adicionarWidget(w) : atualizarWidget(w))}
                />
            )}
            <CompartilharModal
                aberto={compartilharAberto}
                onClose={() => setCompartilharAberto(false)}
                targetRef={pageRef}
                titulo={`Dashboard · ${ap.name}`}
                textoPadrao={`Dashboard ${ap.name} (${(ap.widgets || []).length} widgets).`}
            />
        </div>
    );
}

function WidgetBuilder({ widget, telasBuilt, onClose, onSave }) {
    const isEdit = !!widget;
    const [tipo, setTipo] = useState(widget?.tipo || 'kpi');
    const [titulo, setTitulo] = useState(widget?.titulo || 'Novo widget');
    const [descricao, setDescricao] = useState(widget?.descricao || '');
    const [w, setW] = useState(widget?.w || 6);
    const [origem, setOrigem] = useState(widget?.origem || 'static');
    const [endpoint, setEndpoint] = useState(widget?.endpoint || '');
    const [sql, setSql] = useState(widget?.sql || '');
    const [conexao, setConexao] = useState(widget?.conexao || '');
    const [refresh, setRefresh] = useState(widget?.refresh != null ? widget.refresh : 60);
    const [restMethod, setRestMethod] = useState(widget?.restMethod || 'GET');
    const [restBody, setRestBody] = useState(widget?.restBody || '{}');
    const [restHeaders, setRestHeaders] = useState(widget?.restHeaders || []);
    const [restAuth, setRestAuth] = useState(widget?.restAuth || { tipo: 'none', token: '', user: '', senha: '' });
    const [restDataPath, setRestDataPath] = useState(widget?.restDataPath || '');
    const [availableKeys, setAvailableKeys] = useState([]);
    const [slugAtalho, setSlugAtalho] = useState(widget?.slug || '');
    const [valorStatic, setValorStatic] = useState(widget?.valor || '142');
    const [subStatic, setSubStatic] = useState(widget?.sub != null ? widget.sub : '');
    const [valorTipo, setValorTipo] = useState(widget?.valorTipo || 'texto');
    const [graficoTipo, setGraficoTipo] = useState(widget?.graficoTipo || 'bar');
    const [html, setHtml] = useState(widget?.html || '');
    const [eixoX, setEixoX] = useState(widget?.eixoX || '');
    const [eixoY, setEixoY] = useState(widget?.eixoY || '');
    const [testing, setTesting] = useState(false);
    const [preview, setPreview] = useState(null);
    // [iter6] padrao Construtor: conexoes SQL + editor de colunas
    const [conexoes, setConexoes] = useState([]);
    const [colunas, setColunas] = useState(widget?.colunas || []);
    const [eixoMeta, setEixoMeta] = useState(widget?.eixoMeta || '');
    const [mostrarRotulos, setMostrarRotulos] = useState(widget?.mostrarRotulos != null ? widget.mostrarRotulos : false);
    const [metaCfg, setMetaCfg] = useState(widget?.metaCfg || { lim1: 70, lim2: 100, cor1: '#b91c1c', cor2: '#8a6d00', cor3: '#15643a' });
    useEffect(() => {
        ConsultaConexoes({}).then(r => {
            if (r && !r.Error) setConexoes(Array.isArray(r) ? r : (r.conexoes || []));
        });
    }, []);
    function addColuna() { setColunas([...colunas, { chave: '', label: '', tipo: 'texto', visivel: true }]); }
    function delColuna(i) { setColunas(colunas.filter((_, ix) => ix !== i)); }
    function updColuna(i, k, v) {
        const arr = [...colunas]; arr[i] = { ...arr[i], [k]: v }; setColunas(arr);
    }
    function autoPopulaColunas(rows) {
        if (!Array.isArray(rows) || rows.length === 0) return;
        if (colunas.length > 0) return;
        const linha = rows[0];
        let detectadas = [];
        if (Array.isArray(linha)) {
            detectadas = linha.map((_, i) => {
                const valoresObj = rows.map(r => ({ v: Array.isArray(r) ? r[i] : null }));
                return { chave: 'col' + i, label: 'Coluna ' + i, tipo: inferTipoColuna(valoresObj, 'v'), visivel: true };
            });
        } else if (linha && typeof linha === 'object') {
            detectadas = Object.keys(linha).slice(0, 30).map(k => ({
                chave: k, label: k, tipo: inferTipoColuna(rows, k), visivel: true
            }));
        }
        if (detectadas.length > 0) setColunas(detectadas);
    }

    async function testar() {
        if (origem === 'static') return Swal.fire({ icon: 'info', title: 'Sem origem dinâmica', text: 'Widget estático não tem o que testar.' });
        if (origem === 'rest' && !endpoint) return Swal.fire({ icon: 'warning', title: 'Atenção', text: 'Endpoint obrigatório.' });
        setTesting(true);
        try {
            if (origem === 'rest') {
                const h = { Accept: 'application/json' };
                if (restMethod !== 'GET') h['Content-Type'] = 'application/json';
                restHeaders.forEach(x => { if (x.nome) h[x.nome] = x.valor || ''; });
                if (restAuth.tipo === 'bearer' && restAuth.token) h.Authorization = `Bearer ${restAuth.token}`;
                if (restAuth.tipo === 'basic' && restAuth.user) h.Authorization = 'Basic ' + btoa(`${restAuth.user}:${restAuth.senha || ''}`);
                const init = { method: restMethod, headers: h };
                if (restMethod !== 'GET' && restBody) { try { init.body = JSON.stringify(JSON.parse(restBody)); } catch { init.body = restBody; } }
                const r = await fetch(endpoint, init).catch(err => { throw new Error('Falha rede: ' + err.message); });
                if (!r) throw new Error('Resposta vazia');
                if (!r.ok) throw new Error('HTTP ' + r.status + ' em ' + endpoint);
                const data = await r.json();
                // Resolve data via dataPath se informado
                let resolved = data;
                if (restDataPath) {
                    restDataPath.split('.').forEach(k => { if (resolved != null && k) resolved = resolved[k]; });
                }
                // Detecta keys disponiveis
                const keys = [];
                function scan(obj, prefix) {
                    if (obj == null || typeof obj !== 'object') return;
                    if (Array.isArray(obj)) {
                        keys.push({ caminho: prefix || '(raiz)', tipo: 'array', tamanho: obj.length });
                        if (obj.length > 0 && typeof obj[0] === 'object') {
                            Object.keys(obj[0]).slice(0, 30).forEach(k => keys.push({ caminho: `${prefix}[].${k}`, tipo: typeof obj[0][k] }));
                        }
                    } else {
                        Object.keys(obj).slice(0, 30).forEach(k => {
                            const next = prefix ? `${prefix}.${k}` : k;
                            if (Array.isArray(obj[k])) keys.push({ caminho: next, tipo: 'array', tamanho: obj[k].length });
                            else if (typeof obj[k] === 'object' && obj[k] !== null) scan(obj[k], next);
                            else keys.push({ caminho: next, tipo: typeof obj[k] });
                        });
                    }
                }
                scan(data, '');
                setAvailableKeys(keys.slice(0, 40));
                setPreview({ tipo: 'rest', data: resolved, raw: data });
                // [iter6] autopopula colunas se ainda nao configuradas
                autoPopulaColunas(Array.isArray(resolved) ? resolved : []);
                Swal.fire({ icon: 'success', title: 'Endpoint OK', text: Array.isArray(resolved) ? `${resolved.length} linhas` : 'objeto retornado', timer: 1500, showConfirmButton: false });
            } else if (origem === 'tela') {
                const r = await ExecutaTelaInterna({ slug: slugAtalho });
                if (r.Error) throw new Error(r.Error);
                setPreview({ tipo: 'tela', data: r });
                // [iter6] usa colunas da tela publicada se ainda nao configuradas
                if (colunas.length === 0 && Array.isArray(r.colunas) && r.colunas.length > 0) {
                    setColunas(r.colunas.map(c => ({ chave: c.nome, label: c.label || c.nome, tipo: (r.rows ? inferTipoColuna(r.rows, c.nome) : 'texto'), visivel: true })));
                } else {
                    autoPopulaColunas(Array.isArray(r.rows) ? r.rows : []);
                }
                Swal.fire({ icon: 'success', title: 'Tela OK', timer: 1100, showConfirmButton: false });
            } else if (origem === 'banco') {
                if (!conexao) throw new Error('Conexao obrigatoria.');
                if (!sql) throw new Error('SQL obrigatorio.');
                const _q = montaSqlPeriodo(sql, null);
                const r = await ExecutaConsultaSql({ conexao, sql: _q.sql, params: _q.params });
                if (r.Error) throw new Error(r.Error);
                setPreview({ tipo: 'banco', data: r });
                if (colunas.length === 0 && Array.isArray(r.colunas) && r.colunas.length > 0) {
                    setColunas(r.colunas.map(c => ({ chave: c.nome, label: c.label || c.nome, tipo: (r.rows ? inferTipoColuna(r.rows, c.nome) : 'texto'), visivel: true })));
                } else {
                    autoPopulaColunas(Array.isArray(r.rows) ? r.rows : []);
                }
                Swal.fire({ icon: 'success', title: 'Consulta OK', text: `${(r.rows || []).length} linha(s)`, timer: 1300, showConfirmButton: false });
            }
        } catch (e) {
            Swal.fire({ icon: 'warning', title: 'Erro', text: e.message });
        }
        setTesting(false);
    }

    function publicar() {
        const w_obj = {
            uid: widget?.uid || `${tipo}-${Date.now()}`,
            tipo, titulo, descricao, w, origem,
            eixoX, eixoY,
            endpoint, sql, conexao, refresh,
            restMethod, restBody, restHeaders, restAuth, restDataPath,
            slug: slugAtalho,
            valor: valorStatic, sub: subStatic, valorTipo,
            graficoTipo, html,
            eixoMeta, mostrarRotulos, metaCfg,
            colunas // [iter6] padrao Construtor: persiste a configuracao de colunas
        };
        onSave(w_obj);
    }

    return (
        <div className="modal-mask" onClick={onClose}>
            <div className="modal" style={{ maxWidth: 980, width: '92%' }} onClick={e => e.stopPropagation()}>
                <div className="modal-head">
                    <div>
                        <div className="eyebrow"><span className="num">09</span> Construtor de widget · Dashboard</div>
                        <h2 style={{ fontFamily: 'var(--font-display)', fontWeight: 300, fontSize: 26, margin: '6px 0 0' }}>
                            {isEdit ? 'Editar widget' : 'Configurar novo widget'}
                        </h2>
                        <div style={{ fontSize: 12, color: 'var(--ink-mute)', marginTop: 4 }}>
                            Conecte uma API, consulta SQL ou crie atalhos para telas existentes. O widget vira parte da biblioteca do preset atual.
                        </div>
                    </div>
                    <button className="icon-btn" onClick={onClose}><Icon name="x" size={14}/></button>
                </div>

                <div className="builder-shell" style={{ borderTop: '1px solid var(--line)' }}>
                    <div className="builder-form">
                        <div className="eyebrow" style={{ marginBottom: 10 }}>Tipo de widget</div>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1, background: 'var(--line)', border: '1px solid var(--line)', marginBottom: 18 }}>
                            {TIPOS_WIDGET.map(t => (
                                <button key={t.id} onClick={() => setTipo(t.id)} style={{ background: tipo === t.id ? 'var(--bg-2)' : 'var(--paper)', border: 'none', padding: '14px 16px', textAlign: 'left', cursor: 'pointer', fontFamily: 'inherit', borderLeft: tipo === t.id ? '2px solid var(--ink)' : '2px solid transparent' }}>
                                    <div style={{ fontFamily: 'var(--font-display)', fontWeight: 300, fontSize: 14 }}>{t.label}</div>
                                    <div style={{ marginTop: 4, color: 'var(--ink-mute)', fontSize: 11.5 }}>{t.desc}</div>
                                </button>
                            ))}
                        </div>

                        <div className="field"><label>Título</label><input className="input" value={titulo} onChange={e => setTitulo(e.target.value)}/></div>
                        <div className="field"><label>Descrição (subtítulo)</label><input className="input" value={descricao} onChange={e => setDescricao(e.target.value)}/></div>

                        <div className="field">
                            <label>Largura padrão</label>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 1, background: 'var(--line)', border: '1px solid var(--line)' }}>
                                {SIZES.map(s => (
                                    <button key={s} onClick={() => setW(s)} style={{ background: w === s ? 'var(--bg-2)' : 'var(--paper)', border: 'none', padding: '10px 0', cursor: 'pointer', fontFamily: 'var(--font-mono)', fontSize: 12, fontWeight: w === s ? 500 : 400 }}>{s}/12</button>
                                ))}
                            </div>
                        </div>

                        {(tipo !== 'atalho') && (
                            <div className="field">
                                <label>Origem dos dados</label>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: 1, background: 'var(--line)', border: '1px solid var(--line)' }}>
                                    {[
                                        { id: 'static', lbl: 'Valor fixo',        sub: 'Sem fetch — valor digitado' },
                                        { id: 'banco',  lbl: 'Banco (SQL)',       sub: 'Conexão pg/oracle direta' },
                                        { id: 'rest',   lbl: 'API REST',          sub: 'GET/POST com headers/auth' },
                                        { id: 'tela',   lbl: 'Tela do Construtor',sub: 'Reusa origem publicada' }
                                    ].map(o => (
                                        <button key={o.id} onClick={() => setOrigem(o.id)} style={{ background: origem === o.id ? 'var(--bg-2)' : 'var(--paper)', border: 'none', padding: '12px 14px', textAlign: 'left', cursor: 'pointer', fontFamily: 'inherit', borderLeft: origem === o.id ? '2px solid var(--ink)' : '2px solid transparent' }}>
                                            <div style={{ fontSize: 13, fontWeight: origem === o.id ? 500 : 400 }}>{o.lbl}</div>
                                            <div style={{ fontSize: 10.5, color: 'var(--ink-mute)', marginTop: 2 }}>{o.sub}</div>
                                        </button>
                                    ))}
                                </div>
                            </div>
                        )}

                        {origem === 'rest' && (
                            <>
                                <div style={{ display: 'grid', gridTemplateColumns: '120px 1fr', gap: 10 }}>
                                    <div className="field"><label>Método</label><select className="select" value={restMethod} onChange={e => setRestMethod(e.target.value)}>
                                        {['GET','POST','PUT','PATCH','DELETE'].map(m => <option key={m}>{m}</option>)}
                                    </select></div>
                                    <div className="field"><label>Endpoint</label><input className="input mono" value={endpoint} onChange={e => setEndpoint(e.target.value)} placeholder="/api/... ou URL completa"/></div>
                                </div>
                                {restMethod !== 'GET' && (
                                    <div className="field"><label>Body (JSON)</label><textarea className="textarea mono" rows={3} value={restBody} onChange={e => setRestBody(e.target.value)}/></div>
                                )}
                                <div className="field">
                                    <label>Headers</label>
                                    {restHeaders.map((h, i) => (
                                        <div key={i} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr auto', gap: 6, marginTop: 6 }}>
                                            <input className="input mono" placeholder="Nome" value={h.nome} onChange={e => { const a=[...restHeaders]; a[i]={...a[i], nome: e.target.value}; setRestHeaders(a); }}/>
                                            <input className="input mono" placeholder="Valor" value={h.valor} onChange={e => { const a=[...restHeaders]; a[i]={...a[i], valor: e.target.value}; setRestHeaders(a); }}/>
                                            <button className="btn ghost sm" onClick={() => setRestHeaders(restHeaders.filter((_, ix) => ix !== i))}><Icon name="x" size={11}/></button>
                                        </div>
                                    ))}
                                    <button className="btn ghost sm" style={{ marginTop: 8 }} onClick={() => setRestHeaders([...restHeaders, { nome: '', valor: '' }])}><Icon name="plus" size={11}/> Header</button>
                                </div>
                                <div className="field">
                                    <label>Autenticação</label>
                                    <select className="select" value={restAuth.tipo} onChange={e => setRestAuth({ ...restAuth, tipo: e.target.value })}>
                                        <option value="none">Sem autenticação</option>
                                        <option value="bearer">Bearer token</option>
                                        <option value="basic">Basic auth</option>
                                    </select>
                                </div>
                                {restAuth.tipo === 'bearer' && (
                                    <div className="field"><label>Token</label><input className="input mono" type="password" value={restAuth.token} onChange={e => setRestAuth({ ...restAuth, token: e.target.value })}/></div>
                                )}
                                {restAuth.tipo === 'basic' && (
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                                        <div className="field"><label>Usuário</label><input className="input" value={restAuth.user} onChange={e => setRestAuth({ ...restAuth, user: e.target.value })}/></div>
                                        <div className="field"><label>Senha</label><input className="input" type="password" value={restAuth.senha} onChange={e => setRestAuth({ ...restAuth, senha: e.target.value })}/></div>
                                    </div>
                                )}
                                <div className="field">
                                    <label>Path do array de linhas (opcional)</label>
                                    <input className="input mono" placeholder="ex: data.items ou result.rows — vazio = auto" value={restDataPath} onChange={e => setRestDataPath(e.target.value)}/>
                                    <span className="muted" style={{ fontSize: 11 }}>Se a resposta é {`{ data: { items: [...] } }`}, use <span className="mono">data.items</span>. Vazio detecta automaticamente (rows/data/items).</span>
                                </div>
                                {availableKeys.length > 0 && (
                                    <div className="field">
                                        <label>Caminhos detectados na resposta</label>
                                        <div style={{ maxHeight: 160, overflowY: 'auto', border: '1px solid var(--line)', padding: 6, background: 'var(--bg-2)' }}>
                                            {availableKeys.map((k, i) => (
                                                <div key={i} onClick={() => setRestDataPath(k.caminho.replace(/^\(raiz\)/, '').replace(/^\./, ''))} style={{ padding: '4px 6px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', fontSize: 11, fontFamily: 'var(--font-mono)' }}>
                                                    <span>{k.caminho}</span>
                                                    <span className="muted">{k.tipo}{k.tamanho != null ? `(${k.tamanho})` : ''}</span>
                                                </div>
                                            ))}
                                        </div>
                                        <span className="muted" style={{ fontSize: 11 }}>Clique num caminho para escolhê-lo.</span>
                                    </div>
                                )}
                            </>
                        )}
                        {(origem === 'rest' || origem === 'banco' || origem === 'tela') && (tipo === 'tabela' || tipo === 'grafico') && (
                            <div className="field">
                                <label>Colunas (label, ordem, visibilidade)</label>
                                <p className="muted" style={{ fontSize: 11, marginTop: 2 }}>
                                    Defina labels personalizados e visibilidade. Use "Testar consulta" pra autopopular a partir da resposta.
                                </p>
                                {colunas.length === 0 && (
                                    <div className="muted" style={{ fontSize: 11.5, padding: '8px 0' }}>Nenhuma coluna ainda — teste a origem ou adicione manualmente.</div>
                                )}
                                {colunas.map((c, i) => (
                                    <div key={i} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 110px 80px auto', gap: 6, marginTop: 6, alignItems: 'center' }}>
                                        <input className="input mono" placeholder="chave (api)" value={c.chave} onChange={e => updColuna(i, 'chave', e.target.value)}/>
                                        <input className="input" placeholder="Label visível" value={c.label} onChange={e => updColuna(i, 'label', e.target.value)}/>
                                        <select className="select" value={c.tipo} onChange={e => updColuna(i, 'tipo', e.target.value)}>
                                            {['texto','numero','data','moeda','boolean'].map(t => <option key={t}>{t}</option>)}
                                        </select>
                                        <label className="row-flex" style={{ fontSize: 11 }}><input type="checkbox" checked={c.visivel !== false} onChange={e => updColuna(i, 'visivel', e.target.checked)}/> visível</label>
                                        <button className="btn ghost sm" onClick={() => delColuna(i)}><Icon name="x" size={11}/></button>
                                    </div>
                                ))}
                                <button className="btn ghost sm" style={{ marginTop: 8 }} onClick={addColuna}><Icon name="plus" size={11}/> Adicionar coluna</button>
                            </div>
                        )}
                        {origem === 'banco' && (
                            <>
                                <div className="field">
                                    <label>Conexão</label>
                                    <select className="select" value={conexao} onChange={e => setConexao(e.target.value)}>
                                        <option value="">— escolha —</option>
                                        {conexoes.map(c => <option key={c.id} value={c.prefixo}>{c.prefixo} ({c.driver})</option>)}
                                    </select>
                                    {conexoes.length === 0 && <span className="muted" style={{ fontSize: 11 }}>Cadastre uma em TI · Conexões de Banco primeiro.</span>}
                                </div>
                                <div className="field">
                                    <label>{'SQL ($1,$2 = args - {{data_ini}}/{{data_fim}} = filtro de data do topo)'}</label>
                                    <div style={{ display: 'flex', gap: 6, marginBottom: 6, flexWrap: 'wrap' }}>
                                        <button type="button" className="btn ghost sm" onClick={() => insereTokenTextarea('wb-sql', sql, '{{data_ini}}', setSql)} title="Insere o token de data inicial no cursor">{'+ {{data_ini}}'}</button>
                                        <button type="button" className="btn ghost sm" onClick={() => insereTokenTextarea('wb-sql', sql, '{{data_fim}}', setSql)} title="Insere o token de data final no cursor">{'+ {{data_fim}}'}</button>
                                        <button type="button" className="btn ghost sm" onClick={() => insereTokenTextarea('wb-sql', sql, 'BETWEEN {{data_ini}} AND {{data_fim}}', setSql)} title="Insere o intervalo completo no cursor">+ BETWEEN periodo</button>
                                    </div>
                                    <textarea id="wb-sql" className="textarea mono" rows={8} value={sql} onChange={e => setSql(e.target.value)} placeholder="SELECT id, nome FROM minha_tabela LIMIT 50"/>
                                </div>
                            </>
                        )}
                        {origem === 'tela' && (
                            <div className="field">
                                <label>Tela publicada</label>
                                <select className="select" value={slugAtalho} onChange={e => setSlugAtalho(e.target.value)}>
                                    <option value="">— escolha —</option>
                                    {telasBuilt.map(t => <option key={t.slug} value={t.slug}>{t.nome}</option>)}
                                </select>
                            </div>
                        )}
                        {tipo === 'kpi' && (
                            <>
                                {origem === 'static' ? (
                                    <div className="field"><label>Valor</label><input className="input" value={valorStatic} onChange={e => setValorStatic(e.target.value)}/></div>
                                ) : (colunas.length > 0 ? (
                                    <div className="field">
                                        <label>Coluna do valor (KPI)</label>
                                        <select className="select" value={eixoY} onChange={e => setEixoY(e.target.value)}>
                                            <option value="">(1a coluna do resultado)</option>
                                            {colunas.map(c => <option key={c.chave} value={c.chave}>{c.label || c.chave}</option>)}
                                        </select>
                                    </div>
                                ) : (
                                    <div className="muted" style={{ fontSize: 11.5 }}>Use "Testar consulta" para escolher a coluna do valor (senão usa a 1a).</div>
                                ))}
                                {origem !== 'static' && (
                                    <div className="field"><label>Tipo do valor</label>
                                        <select className="select" value={valorTipo} onChange={e => setValorTipo(e.target.value)}>
                                            <option value="texto">Texto (como vem)</option>
                                            <option value="numero">Número</option>
                                            <option value="moeda">Moeda (R$)</option>
                                            <option value="data">Data</option>
                                            <option value="hora">Hora</option>
                                        </select>
                                    </div>
                                )}
                                <div className="field"><label>Sub-texto (opcional)</label><input className="input" value={subStatic} onChange={e => setSubStatic(e.target.value)}/></div>
                            </>
                        )}
                        {tipo === 'html' && (
                            <div className="field">
                                <label>HTML (renderizado no widget)</label>
                                <textarea className="textarea mono" rows={8} value={html} onChange={e => setHtml(e.target.value)} placeholder="<h3>Titulo</h3><p>Conteudo livre...</p>"/>
                            </div>
                        )}

                        {tipo === 'grafico' && (
                            <>
                                <div className="field">
                                    <label>Tipo de gráfico</label>
                                    <select className="select" value={graficoTipo} onChange={e => setGraficoTipo(e.target.value)}>
                                        {CHART_TIPOS.map(t => <option key={t.id} value={t.id}>{t.label}</option>)}
                                        <option value="kpi-spark">KPI com sparkline</option>
                                    </select>
                                </div>
                                {colunas.length > 0 && (
                                    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
                                        <div className="field">
                                            <label>Eixo X (categoria)</label>
                                            <select className="select" value={eixoX} onChange={e => setEixoX(e.target.value)}>
                                                <option value="">— escolha —</option>
                                                {colunas.map(c => <option key={c.chave} value={c.chave}>{c.label || c.chave}</option>)}
                                            </select>
                                        </div>
                                        <div className="field">
                                            <label>Eixo Y (valor numérico)</label>
                                            <select className="select" value={eixoY} onChange={e => setEixoY(e.target.value)}>
                                                <option value="">— escolha —</option>
                                                {colunas.filter(c => c.tipo === 'numero' || c.tipo === 'moeda').map(c => <option key={c.chave} value={c.chave}>{c.label || c.chave}</option>)}
                                                <option disabled>───</option>
                                                {colunas.filter(c => c.tipo !== 'numero' && c.tipo !== 'moeda').map(c => <option key={c.chave} value={c.chave}>{c.label || c.chave} ({c.tipo})</option>)}
                                            </select>
                                        </div>
                                    </div>
                                )}
                                {colunas.length > 0 && (
                                    <div className="field">
                                        <label>Coluna da meta (opcional)</label>
                                        <select className="select" value={eixoMeta} onChange={e => setEixoMeta(e.target.value)}>
                                            <option value="">— sem meta —</option>
                                            {colunas.filter(c => c.chave !== eixoY).map(c => <option key={c.chave} value={c.chave}>{c.label || c.chave}</option>)}
                                        </select>
                                    </div>
                                )}
                                {colunas.length > 0 && (
                                    <div className="field">
                                        <label style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer' }}>
                                            <input type="checkbox" checked={mostrarRotulos} onChange={e => setMostrarRotulos(e.target.checked)}/>
                                            Mostrar rótulos de valor nas barras/linhas
                                        </label>
                                    </div>
                                )}
                                {eixoMeta && (
                                    <div className="field">
                                        <label>Cores por % da meta (valor ÷ meta)</label>
                                        <div style={{ display:'flex', alignItems:'center', gap:6, flexWrap:'wrap', fontSize:12 }}>
                                            <input type="color" value={metaCfg.cor1} onChange={e => setMetaCfg({ ...metaCfg, cor1: e.target.value })} title="Abaixo do 1o limite"/>
                                            <span className="muted">&lt;</span>
                                            <input className="input" style={{ width:54 }} type="number" value={metaCfg.lim1} onChange={e => setMetaCfg({ ...metaCfg, lim1: Number(e.target.value) })}/>
                                            <span className="muted">% ·</span>
                                            <input type="color" value={metaCfg.cor2} onChange={e => setMetaCfg({ ...metaCfg, cor2: e.target.value })} title="Intermediario"/>
                                            <span className="muted">&lt;</span>
                                            <input className="input" style={{ width:54 }} type="number" value={metaCfg.lim2} onChange={e => setMetaCfg({ ...metaCfg, lim2: Number(e.target.value) })}/>
                                            <span className="muted">% ·</span>
                                            <input type="color" value={metaCfg.cor3} onChange={e => setMetaCfg({ ...metaCfg, cor3: e.target.value })} title="Atingiu/ultrapassou"/>
                                            <span className="muted">&#8805;</span>
                                        </div>
                                    </div>
                                )}
                                {colunas.length === 0 && (
                                    <div className="muted" style={{ fontSize:11.5 }}>Teste a origem primeiro para listar as colunas nos eixos.</div>
                                )}
                            </>
                        )}

                        {tipo === 'atalho' && (
                            <div className="field">
                                <label>Tela publicada</label>
                                <select className="select" value={slugAtalho} onChange={e => setSlugAtalho(e.target.value)}>
                                    <option value="">— escolha —</option>
                                    {telasBuilt.map(t => <option key={t.slug} value={t.slug}>{t.nome}</option>)}
                                </select>
                            </div>
                        )}

                        {origem !== 'static' && (
                            <div className="field">
                                <label>Atualizar a cada</label>
                                <select className="select" value={refresh} onChange={e => setRefresh(parseInt(e.target.value, 10))}>
                                    {REFRESH_OPTS.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
                                </select>
                            </div>
                        )}

                        <div className="card flat" style={{ marginTop: 14, fontSize: 11.5, padding: '12px 14px', background: 'var(--bg-2)' }}>
                            <div className="eyebrow" style={{ marginBottom: 4 }}><Icon name="shield" size={11}/> TI · publica na biblioteca</div>
                            O widget é cadastrado em <span className="mono">/secure/dashboard.json</span>, fica disponível na biblioteca e respeita as Permissões de Telas do setor.
                        </div>
                    </div>

                    <div className="builder-preview">
                        <div className="eyebrow" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <span>Preview</span>
                            <span className="muted" style={{ fontSize: 10 }}>AO VIVO</span>
                        </div>
                        <div style={{ fontSize: 11, color: 'var(--ink-mute)', marginTop: 4 }}>Largura {w}/12 · 1 linha</div>

                        <div className="widget" data-w={w} style={{ marginTop: 14, minHeight: 160 }}>
                            <PreviewWidget tipo={tipo} titulo={titulo} descricao={descricao} valor={valorStatic} sub={subStatic} preview={preview} graficoTipo={graficoTipo} html={html}/>
                        </div>
                    </div>
                </div>

                <div className="modal-foot">
                    <span className="muted" style={{ fontSize: 11, marginRight: 'auto' }}>{isEdit ? `Editando · ${widget.uid}` : 'Novo widget'}</span>
                    <button className="btn ghost sm" onClick={onClose}>Cancelar</button>
                    <button className="btn ghost sm" onClick={testar} disabled={testing || origem === 'static'}>
                        {testing ? 'Testando…' : 'Testar consulta'}
                    </button>
                    <button className="btn sm" onClick={publicar}>{isEdit ? 'Salvar widget' : 'Publicar widget'}</button>
                </div>
            </div>
        </div>
    );
}

function PreviewWidget({ tipo, titulo, descricao, valor, sub, preview, graficoTipo, html }) {
    if (tipo === 'kpi') {
        const _pr0 = preview && preview.data && Array.isArray(preview.data.rows) ? preview.data.rows[0] : null;
        const valorKpi = _pr0 != null ? (typeof _pr0 === 'object' ? Object.values(_pr0)[0] : _pr0) : valor;
        return (
            <>
                <div className="widget-head"><span className="widget-eyebrow">KPI</span></div>
                <div className="muted" style={{ fontSize: 10, letterSpacing: '0.22em', textTransform: 'uppercase', marginBottom: 4 }}>{titulo}</div>
                <div className="kpi-big">
                    <div className="v">{valorKpi != null ? String(valorKpi) : valor}</div>
                    {sub && <div className="sub">{sub}</div>}
                    {descricao && <div className="muted" style={{ fontSize: 11, marginTop: 6 }}>{descricao}</div>}
                </div>
            </>
        );
    }
    if (tipo === 'grafico') {
        const mock = [40, 65, 38, 80, 50, 90, 60, 70];
        if (graficoTipo === 'bar') return (
            <>
                <div className="widget-head"><div className="widget-title">{titulo}</div><span className="widget-eyebrow">{graficoTipo}</span></div>
                <div className="bars">{mock.map((v, i) => <span key={i} className="bar" style={{ height: `${v}%` }}/>)}</div>
            </>
        );
        if (graficoTipo === 'line') return (
            <>
                <div className="widget-head"><div className="widget-title">{titulo}</div></div>
                <svg width="100%" height={100} viewBox="0 0 200 100" preserveAspectRatio="none">
                    <polyline points={mock.map((v, i) => `${i * 28},${100 - v}`).join(' ')} fill="none" stroke="var(--ink)" strokeWidth={1.4}/>
                </svg>
            </>
        );
        return <div className="muted">Preview do gráfico {graficoTipo}</div>;
    }
    if (tipo === 'tabela') {
        const cols = preview?.data?.colunas || [{ nome: 'id' }, { nome: 'nome' }];
        const rows = preview?.data?.rows || preview?.data?.slice?.(0, 5) || [{ id: 7, nome: 'Valor 1' }, { id: 14, nome: 'Valor 2' }];
        return (
            <>
                <div className="widget-head"><div className="widget-title">{titulo}</div></div>
                <table className="preview-table" style={{ fontSize: 11 }}>
                    <thead><tr>{cols.slice(0, 3).map(c => <th key={c.nome || c}>{(c.nome || c).toUpperCase()}</th>)}</tr></thead>
                    <tbody>{rows.slice(0, 4).map((r, i) => <tr key={i}>{cols.slice(0, 3).map(c => <td key={c.nome || c}>{String(r[c.nome || c] ?? '—')}</td>)}</tr>)}</tbody>
                </table>
            </>
        );
    }
    if (tipo === 'atalho') {
        return (
            <>
                <div className="widget-head"><span className="widget-eyebrow">ATALHO</span></div>
                <div style={{ fontFamily: 'var(--font-display)', fontWeight: 300, fontSize: 22, marginTop: 8 }}>{titulo}</div>
                <div className="muted" style={{ fontSize: 12, marginTop: 8 }}>{descricao || 'Atalho rápido para uma tela.'}</div>
                <div style={{ marginTop: 12, display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 12 }}>
                    Abrir <Icon name="arrow-right" size={10}/>
                </div>
            </>
        );
    }
    if (tipo === 'html') {
        return (
            <>
                <div className="widget-head"><span className="widget-eyebrow">HTML</span></div>
                <div className="widget-html" dangerouslySetInnerHTML={{ __html: html || '<span class="muted">Cole o HTML no editor…</span>' }}/>
            </>
        );
    }
    return null;
}

function WidgetCard({ w, editing, telasBuilt, periodo, onRemove, onResize, onEdit, onDragStart, onDragOver, onDrop }) {
    return (
        <div
            className="widget"
            data-w={w.w || 4}
            draggable={editing}
            onDragStart={onDragStart}
            onDragOver={onDragOver}
            onDrop={onDrop}
            style={editing ? { cursor: 'move', border: '1px dashed var(--ink-mute)' } : undefined}
        >
            {editing && (
                <div style={{ position: 'absolute', top: 6, right: 6, display: 'flex', gap: 4, zIndex: 2 }}>
                    <button className="btn ghost sm" onClick={() => onResize(-1)} title="Diminuir">−</button>
                    <button className="btn ghost sm" onClick={() => onResize(1)} title="Aumentar">+</button>
                    <button className="btn ghost sm" onClick={onEdit} title="Editar"><Icon name="edit" size={10}/></button>
                    <button className="btn ghost sm" onClick={onRemove} title="Remover"><Icon name="x" size={10}/></button>
                </div>
            )}
            <div className="widget-head">
                <div className="widget-title">{w.titulo}</div>
                {w.tipo === 'pulso' && <span className="widget-eyebrow">24h</span>}
                {w.tipo === 'kpi' && <span className="widget-eyebrow">KPI</span>}
            </div>
            <WidgetBody w={w} telasBuilt={telasBuilt} periodo={periodo}/>
        </div>
    );
}

function WidgetBody({ w, telasBuilt, periodo }) {
    if (w.tipo === 'kpi') {
        return <KpiWidget w={w} periodo={periodo}/>;
    }
    if (w.tipo === 'pulso') {
        return (
            <div className="bars">
                {Array.from({ length: 24 }).map((_, i) => (
                    <span key={i} className="bar" style={{ height: `${30 + Math.random() * 70}%`, background: i % 5 === 2 ? 'var(--nude-deep)' : 'var(--ink)' }}/>
                ))}
            </div>
        );
    }
    if (w.tipo === 'infra') {
        const list = [
            { nome: 'NODECLOUD',          sub: '177.70.12.42', status: 'ok' },
            { nome: 'PostgreSQL Cloud',   sub: 'pg.babita.local', status: 'ok' },
            { nome: '\\\\fileserver-babita', sub: 'SMB', status: 'ok' },
            { nome: '@babita_central_bot', sub: 'Telegram', status: 'ok' }
        ];
        return (
            <div className="list-rows">
                {list.map((s, i) => (
                    <div className="row" key={i}>
                        <div><span className={`dot ${s.status}`}/><b style={{ marginLeft: 4 }}>{s.nome}</b><div className="mono muted" style={{ fontSize: 11, marginLeft: 18 }}>{s.sub}</div></div>
                        <span className="muted">OK</span>
                    </div>
                ))}
            </div>
        );
    }
    if (w.tipo === 'atalho') {
        const tela = telasBuilt.find(t => t.slug === w.slug);
        return (
            <div>
                <div style={{ fontSize: 12, color: 'var(--ink-mute)' }}>{tela ? tela.descricao : (w.descricao || 'Selecione uma tela')}</div>
                <a href={w.slug ? `/internas/${w.slug}` : '#'} style={{ marginTop: 12, display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 12, textDecoration: 'none', color: 'var(--ink)' }}>
                    Abrir <Icon name="arrow-right" size={10}/>
                </a>
            </div>
        );
    }
    if (w.tipo === 'grafico') {
        return <GraficoWidget w={w} telasBuilt={telasBuilt} periodo={periodo}/>;
    }
    if (w.tipo === 'tabela') {
        return <TabelaWidget w={w} periodo={periodo}/>;
    }
    if (w.tipo === 'html') {
        return <div className="widget-html" dangerouslySetInnerHTML={{ __html: w.html || '<span class="muted">Sem HTML</span>' }}/>;
    }
    return <div className="muted">Widget {w.tipo}</div>;
}


// Render real de widget grafico (bar/line/donut/kpi-spark) com fetch ao vivo
function GraficoWidget({ w, periodo }) {
    const [rows, setRows] = useState([]);
    const [erro, setErro] = useState('');

    useEffect(() => {
        let cancelado = false;
        async function carregar() {
            try {
                let dados = [];
                if (w.origem === 'tela' && w.slug) {
                    const { ExecutaTelaInterna } = await import('../lib/api');
                    const r = await ExecutaTelaInterna({ slug: w.slug, args: { data_ini: (periodo && periodo.ini) ? periodo.ini : '', data_fim: (periodo && periodo.fim) ? periodo.fim : '' } });
                    if (r.Error) throw new Error(r.Error);
                    dados = r.rows || [];
                } else if (w.origem === 'banco' && w.conexao && w.sql) {
                    const { ExecutaConsultaSql } = await import('../lib/api');
                    const _q = montaSqlPeriodo(w.sql, periodo);
                    const r = await ExecutaConsultaSql({ conexao: w.conexao, sql: _q.sql, params: _q.params });
                    if (r.Error) throw new Error(r.Error);
                    dados = r.rows || [];
                } else if (w.origem === 'rest' && w.endpoint) {
                    const init = { method: w.metodo || 'GET', headers: { 'Content-Type': 'application/json' } };
                    if (w.body && init.method !== 'GET') init.body = w.body;
                    const r = await fetch(w.endpoint, init);
                    const ct = r.headers.get('content-type') || '';
                    const body = ct.includes('application/json') ? await r.json() : await r.text();
                    if (Array.isArray(body)) dados = body;
                    else if (body && Array.isArray(body.rows)) dados = body.rows;
                    else if (body && Array.isArray(body.data)) dados = body.data;
                    else if (body && typeof body === 'object') dados = [body];
                }
                if (!cancelado) setRows(dados);
            } catch (e) {
                if (!cancelado) setErro(e.message);
            }
        }
        carregar();
        const ms = (w.atualizarSeg ? w.atualizarSeg * 1000 : 0);
        const t = ms > 0 ? setInterval(carregar, ms) : null;
        return () => { cancelado = true; if (t) clearInterval(t); };
    }, [w.origem, w.slug, w.conexao, w.sql, w.endpoint, w.metodo, w.body, w.atualizarSeg, periodo && periodo.ini, periodo && periodo.fim]);

    if (erro) return <div className="muted" style={{ fontSize: 11.5, color: '#c0392b', wordBreak:'break-word' }}>{erro}</div>;
    const _tipoG = w.graficoTipo || 'bar';
    const _precisaXY = !['kpi', 'kpi-spark', 'histogram'].includes(_tipoG);
    if (_precisaXY && (!w.eixoX || !w.eixoY)) return <div className="muted" style={{ fontSize: 12 }}>{w.descricao || 'Configure os eixos (X e Y) no widget builder'}</div>;
    // NAO passamos 'titulo': o card do dashboard ja mostra w.titulo em .widget-title logo acima
    // (passar de novo fazia o Chart repetir o mesmo texto como eyebrow dentro do grafico).
    return <Chart cfg={{ tipo: w.graficoTipo || 'bar', x: w.eixoX, y: w.eixoY, serie: w.serie, valor: w.valor, size: w.size, meta: w.eixoMeta, rotulos: w.mostrarRotulos, metaCfg: w.metaCfg, grupo: w.eixoGrupo, kpiPar: w.kpiPar, kpiEscala: w.kpiEscala, escala: w.escala, escalaFonte: w.escalaFonte, altura: w.altura, eixoCurto: w.eixoCurto, mostrarTotal: w.mostrarTotal, totalColuna: w.totalColuna, rotuloTotal: w.rotuloTotal, total2Coluna: w.total2Coluna, rotuloTotal2: w.rotuloTotal2, colunaExtra: w.colunaExtra, rotuloExtra: w.rotuloExtra, mostrarEixo: w.mostrarEixo, semEixo: w.semEixo, rotuloValor: w.rotuloValor, rotuloMeta: w.rotuloMeta, metaParte: w.metaParte }} rows={rows} compact={true}/>;
}



// ---------------------------------------------------------------------------
// Render ao vivo de KPI e Tabela a partir da origem do widget (banco/tela/rest)
// — sem depender do Construtor. SQL roda no backend via ExecutaConsultaSql.
// ---------------------------------------------------------------------------
// Retorna a data de hoje em ISO local (YYYY-MM-DD), sem fuso UTC.
function hojeISO() {
    const d = new Date();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return d.getFullYear() + '-' + mm + '-' + dd;
}

// Insere um token no textarea pelo id, na posicao do cursor (fallback: fim). Atualiza via setter.
function insereTokenTextarea(id, valorAtual, token, setter) {
    const el = (typeof document !== 'undefined') ? document.getElementById(id) : null;
    const v = valorAtual || '';
    let ini = v.length, fim = v.length;
    if (el && el.selectionStart != null) { ini = el.selectionStart; fim = el.selectionEnd; }
    const novo = v.slice(0, ini) + token + v.slice(fim);
    setter(novo);
    if (el) setTimeout(() => { try { el.focus(); el.selectionStart = el.selectionEnd = ini + token.length; } catch (_) {} }, 0);
}

// Substitui os tokens {{data_ini}}/{{data_fim}} do SQL por binds parametrizados ($N).
// Sem tokens -> params vazio (comportamento inalterado). Data vazia -> range total (sem filtro efetivo).
function montaSqlPeriodo(sql, periodo) {
    const params = [];
    let out = String(sql || '');
    if (out.includes('{{data_ini}}')) {
        params.push((periodo && periodo.ini) ? periodo.ini : '1900-01-01');
        out = out.split('{{data_ini}}').join('$' + params.length);
    }
    if (out.includes('{{data_fim}}')) {
        params.push((periodo && periodo.fim) ? periodo.fim : '2999-12-31');
        out = out.split('{{data_fim}}').join('$' + params.length);
    }
    return { sql: out, params };
}

async function buscaDadosWidget(w, periodo) {
    const api = await import('../lib/api');
    if (w.origem === 'banco' && w.conexao && w.sql) {
        const _q = montaSqlPeriodo(w.sql, periodo);
        const r = await api.ExecutaConsultaSql({ conexao: w.conexao, sql: _q.sql, params: _q.params });
        if (r.Error) throw new Error(r.Error);
        return { rows: r.rows || [], colunas: r.colunas || [] };
    }
    if (w.origem === 'tela' && w.slug) {
        const r = await api.ExecutaTelaInterna({ slug: w.slug, args: { data_ini: (periodo && periodo.ini) ? periodo.ini : '', data_fim: (periodo && periodo.fim) ? periodo.fim : '' } });
        if (r.Error) throw new Error(r.Error);
        return { rows: r.rows || [], colunas: r.colunas || [] };
    }
    if (w.origem === 'rest' && w.endpoint) {
        const init = { method: w.metodo || w.restMethod || 'GET', headers: { 'Content-Type': 'application/json' } };
        if (init.method !== 'GET' && (w.body || w.restBody)) init.body = w.body || w.restBody;
        const r = await fetch(w.endpoint, init);
        const ct = r.headers.get('content-type') || '';
        const body = ct.includes('application/json') ? await r.json() : await r.text();
        let rows = [];
        if (Array.isArray(body)) rows = body;
        else if (body && Array.isArray(body.rows)) rows = body.rows;
        else if (body && Array.isArray(body.data)) rows = body.data;
        else if (body && typeof body === 'object') rows = [body];
        return { rows, colunas: [] };
    }
    return { rows: [], colunas: [] };
}

function intervaloMs(w) {
    return w.atualizarSeg ? w.atualizarSeg * 1000 : (w.refresh ? w.refresh * 1000 : 0);
}

function fmtValorKpi(v, tipo) {
    const s = String(v);
    if (tipo === 'moeda') { const n = Number(v); return isNaN(n) ? s : n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); }
    if (tipo === 'numero') { const n = Number(v); return isNaN(n) ? s : n.toLocaleString('pt-BR'); }
    if (tipo === 'data' || tipo === 'hora') {
        const d = new Date(v);
        if (!isNaN(d.getTime())) return tipo === 'hora' ? d.toLocaleTimeString('pt-BR') : d.toLocaleDateString('pt-BR');
        return s;
    }
    return s;
}
function KpiWidget({ w, periodo }) {
    const [valor, setValor] = useState(w.valor || '—');
    const [erro, setErro] = useState('');
    useEffect(() => {
        if (!w.origem || w.origem === 'static') { setValor(w.valor || '—'); setErro(''); return; }
        let cancelado = false;
        async function carregar() {
            try {
                const { rows } = await buscaDadosWidget(w, periodo);
                if (cancelado) return;
                const linha = rows[0];
                let v = '—';
                if (linha != null) {
                    if (typeof linha === 'object') {
                        let chave = w.eixoY || (w.colunas && w.colunas[0] && w.colunas[0].chave) || Object.keys(linha)[0];
                        v = linha[chave];
                        if (v === undefined && Object.keys(linha).length) v = linha[Object.keys(linha)[0]]; // coluna configurada ausente no resultado (ex.: SQL com alias diferente) -> usa a 1a coluna real
                    } else { v = linha; }
                }
                setErro('');
                setValor(v != null ? fmtValorKpi(v, w.valorTipo) : '—');
            } catch (e) { if (!cancelado) setErro(e.message); }
        }
        carregar();
        const ms = intervaloMs(w);
        const t = ms > 0 ? setInterval(carregar, ms) : null;
        return () => { cancelado = true; if (t) clearInterval(t); };
    }, [w, periodo]); // eslint-disable-line react-hooks/exhaustive-deps
    return (
        <div className="kpi-big">
            <div className="v">{erro ? '—' : valor}</div>
            {w.sub && <div className="sub">{w.sub}</div>}
            {erro && <div className="muted" style={{ fontSize: 10.5, color: '#c0392b', wordBreak: 'break-word' }}>{erro}</div>}
        </div>
    );
}

function TabelaWidget({ w, periodo }) {
    const [rows, setRows] = useState([]);
    const [erro, setErro] = useState('');
    useEffect(() => {
        if (!w.origem || w.origem === 'static') { setRows([]); setErro(''); return; }
        let cancelado = false;
        async function carregar() {
            try {
                const r = await buscaDadosWidget(w, periodo);
                if (!cancelado) { setRows(r.rows || []); setErro(''); }
            } catch (e) { if (!cancelado) setErro(e.message); }
        }
        carregar();
        const ms = intervaloMs(w);
        const t = ms > 0 ? setInterval(carregar, ms) : null;
        return () => { cancelado = true; if (t) clearInterval(t); };
    }, [w, periodo]); // eslint-disable-line react-hooks/exhaustive-deps

    const colsCfg = (w.colunas || []).filter(c => c.visivel !== false);
    const cols = colsCfg.length > 0
        ? colsCfg.map(c => ({ chave: c.chave, label: c.label || c.chave }))
        : (rows[0] && typeof rows[0] === 'object' ? Object.keys(rows[0]).slice(0, 6).map(k => ({ chave: k, label: k })) : []);

    if (!w.origem || w.origem === 'static') return <div className="muted" style={{ fontSize: 12 }}>{w.descricao || 'Tabela sem origem dinamica.'}</div>;
    if (erro) return <div className="muted" style={{ fontSize: 11.5, color: '#c0392b', wordBreak: 'break-word' }}>{erro}</div>;
    if (cols.length === 0) return <div className="muted" style={{ fontSize: 12 }}>{w.descricao || 'Sem colunas — teste a consulta no widget builder.'}</div>;
    return (
        <table className="preview-table" style={{ fontSize: 11, marginTop: 6 }}>
            <thead><tr>{cols.slice(0, 6).map(c => <th key={c.chave}>{(c.label || c.chave).toUpperCase()}</th>)}</tr></thead>
            <tbody>
                {rows.slice(0, 50).map((r, i) => (
                    <tr key={i}>{cols.slice(0, 6).map(c => <td key={c.chave}>{String(r[c.chave] != null ? r[c.chave] : '—')}</td>)}</tr>
                ))}
                {rows.length === 0 && <tr><td colSpan={cols.length || 1} className="muted">—</td></tr>}
            </tbody>
        </table>
    );
}
